import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { reportMvpProductionEnvIssues } from './config/mvpProductionEnv';
import { applyThemeToDocument, readStoredTheme } from './utils/themePreference';
import './index.css';

reportMvpProductionEnvIssues();
applyThemeToDocument(readStoredTheme() ?? 'light');

// Suppress ResizeObserver loop errors - these are benign browser warnings
// that occur when ResizeObserver callbacks trigger layout changes.
// This is a known issue with certain browser implementations and third-party libraries (e.g. Ant Design).
function isResizeObserverError(msg: string | undefined): boolean {
  return !!msg && msg.includes('ResizeObserver loop');
}

const originalError = window.console.error;
window.console.error = (...args: unknown[]) => {
  const first = args[0];
  if (typeof first === 'string' && isResizeObserverError(first)) return;
  if (first instanceof Error && isResizeObserverError(first.message)) return;
  originalError.apply(console, args);
};

// Suppress ResizeObserver errors in window error handler (capture phase to run first)
window.addEventListener(
  'error',
  (event) => {
    if (isResizeObserverError(event.message) || isResizeObserverError(event.error?.message)) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  },
  true
);

// Suppress ResizeObserver errors in unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message ?? String(event.reason);
  if (isResizeObserverError(msg)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
